import { MouseEvent, useCallback, useMemo } from 'react';
import { Header, SortingState, flexRender } from '@tanstack/react-table';
import { Button, Icon, Icons } from 'Components/Primitives';
import { TableSortIcon } from 'Components/Table/Table/TableHead/TableSortIcon';

export const TableHeadCellContent = <T extends object>(props: {
  header: Header<T, unknown>;
  sortingState: SortingState;
  sortable?: boolean;
  onColumnRemove?(colId: string): void;
}) => {
  const { header, sortingState, sortable, onColumnRemove } = props;

  const sortDirection = useMemo((): 'asc' | 'desc' | undefined => {
    const sortColumn = sortingState.find((s) => s.id === header.column.id);
    return sortColumn ? (sortColumn.desc ? 'desc' : 'asc') : undefined;
  }, [header, sortingState]);

  const onCloseClick = useCallback(
    (e: MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      onColumnRemove && onColumnRemove(header.id);
    },
    [header, onColumnRemove]
  );

  return sortable ? (
    <div
      {...{
        className: 'header-content',
        onClick: header.column.getToggleSortingHandler()
      }}
    >
      <div>{flexRender(header.column.columnDef.header, header.getContext())}</div>{' '}
      <div>
        <TableSortIcon direction={sortDirection} />
        {onColumnRemove && (
          <Button
            className="remove-col-button"
            type="text"
            icon={<Icon className="close-icon" icon={Icons.CloseRound} />}
            onClick={onCloseClick}
          />
        )}
      </div>
    </div>
  ) : (
    <div className="header-content">
      <div>
        {flexRender(header.column.columnDef.header, header.getContext())}
        {onColumnRemove && (
          <Button
            className="remove-col-button"
            type="text"
            icon={<Icon className="close-icon" icon={Icons.CloseRound} />}
            onClick={onCloseClick}
          />
        )}
      </div>
    </div>
  );
};
